import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

import pic1 from '../../../assets/img/image-004.jpeg';
import img1 from '../../../assets/img/fondo2.png';
import logo from '../../../assets/img/logo-TAD-d.png';


class Enroll extends Component {
    render() {
        return (
            <div className="header-banner" style={{ backgroundImage:`url(${ img1})`}}>
                <Row>
                    <Col md={6} align = "center" style={{padding: 80}}>
                        <h2 style={{color:"white"}}><strong>Clases de Inglés personalizadas</strong></h2>
                        <p  style={{color:"white"}} align="justify">
                            Nuestras clases personalizadas a domicilio se adaptan al lugar y horario que necesites. Al optar por este método obtienes la facilidad y flexibilidad de tener clases donde gustes en acuerdo con el teacher. Nuestro sistema de estudio ofrece distintas modalidades cada una se diferencia en horarios y costos.
                        </p>
                    </Col>
                    <Col md={6} align = "center" style={{minHeight:"88vh"}}>
                        <img src = {pic1} alt = "image_001" className="img img-thumbnail" height="auto" width="300px" style = {{marginTop: "15vh"}}/>

                    </Col>
                </Row>
            </div>
        );
    }
}

export default Enroll;


// WEBPACK FOOTER //
// ./src/site/Componentes/Index/Enroll.jsx